function pluralForm(value) {
  return value === 1 ? 'one' : 'other'
}

export default function Plural({ value, ...props }) {
  return (props[pluralForm(value)] || props.other || '').replace('#', value)
}
